import { useLayout } from "@/contexts/LayoutContext";
import { Monitor, Smartphone, Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LayoutToggle = () => {
  const { layoutMode, setLayoutMode } = useLayout();

  const icon =
    layoutMode === "mobile" ? <Smartphone className="h-4 w-4" /> :
    layoutMode === "desktop" ? <Monitor className="h-4 w-4" /> :
    <Settings2 className="h-4 w-4" />;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="rounded-full h-8 w-8 text-gold/70 hover:text-gold">
          {icon}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem
          onClick={() => setLayoutMode("auto")}
          className={layoutMode === "auto" ? "text-gold font-medium" : ""}
        >
          <Settings2 className="h-4 w-4 mr-2" />
          Auto
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setLayoutMode("desktop")}
          className={layoutMode === "desktop" ? "text-gold font-medium" : ""}
        >
          <Monitor className="h-4 w-4 mr-2" />
          Desktop
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setLayoutMode("mobile")}
          className={layoutMode === "mobile" ? "text-gold font-medium" : ""}
        >
          <Smartphone className="h-4 w-4 mr-2" />
          Mobile
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LayoutToggle;
